export class DollarCentsValueConverter {
    toView(value) {
        if (!isNaN(parseFloat(value) && isFinite(value))) {
            return value / 100;
        }

        if (value == 'Open') {
            return value;
        }
    }

    fromView(value) {
        if (value && typeof value == 'string' && value.toLowerCase() == 'open') {
            return 0;
        }

        if (typeof value != 'string') value = value.toString();

        let tempValue = value.replace(/,/g, '');
        tempValue = tempValue.replace('.', '');

        if (!isNaN(parseInt(tempValue))) {
            return parseInt(tempValue);
        }
    }
}
